<template>
    <div class="support-overlay">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.support-overlay {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    height: 100%;
    background-color: white;
    z-index: 9999999999;
    @include desktop-only {
        border-radius: 16px;
    }
}
</style>
